export default "__VITE_ASSET__CI8rzzH3__"